import React, { useMemo, useState } from 'react';
import { Link } from 'react-navi';
import { NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function AgeStock() {
  return (
    <div>
      <Helmet>
        <meta
          content={`「FRESH CAMPUS CONTEST 2019 supported by リゼクリニック ・メンズリゼ」表彰式開催決定！ | ${
            process.env.REACT_APP_WEBSITE_NAME
          }`}
          property="og:title"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-10-04`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-10-04`} aria-current="page">
                  表彰式開催決定！
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-small">
          <div className="content">
            <h3>「FRESH CAMPUS CONTEST 2019 supported by リゼクリニック ・メンズリゼ」表彰式開催決定！</h3>
            {/*<p className="has-text-centered">*/}
            {/*<img src={"/images/logo_black.svg"} width={240} />*/}
            {/*</p>*/}
            <a className="notification is-warning is-block is-size-7" href="/news/2019-11-11-faq">
              表彰式の注意事項・よくある質問は<span className="has-text-underline" >こちら</span>をご覧ください。
            </a>
            <p>
              2019年11月17日(日)東京ドームシティホールにて行われる日本最大級の合同学園祭「AGESTOCK2019 in TOKYO DOME
              CITY HALL」内にて「FRESH CAMPUS CONTEST2019 supported by リゼクリニック
              ・メンズリゼ」表彰式開催が決定致しました。
              <br />
              <br />
            </p>
            <div>
              <h4>「AGESTOCK2019 in TOKYO DOME CITY HALL」</h4>
              <table className="table is-striped">
                <tbody>
                  <tr>
                    <th>開催日時</th>
                    <td>
                      2019年11月17日（日）
                      <br />
                      【開場】16:00【開演】17:00【終演】20:30
                    </td>
                  </tr>
                  <tr>
                    <th>会場</th>
                    <td>
                      TOKYO DOME CITY HALL <br />
                      （東京都文京区後楽1-3-61 東京ドームシティMEETS PORT内）
                    </td>
                  </tr>
                  <tr>
                    <th>主催</th>
                    <td>
                      AGESTOCK2019実行委員会 <br />（<a className="has-text-primary"  href="http://agestock.jp/2019">http://agestock.jp/2019</a>）
                    </td>
                  </tr>
                  <tr>
                    <th>チケット</th>
                    <td>学生販売¥1500 + 1DRINK（¥500）/ 一般販売¥2500 + 1DRINK （¥500）</td>
                  </tr>
                  <tr>
                    <th>チケット受付開始日</th>
                    <td>学生販売10月6日(日)18時より/ 一般販売10月13日(日)18時より</td>
                  </tr>
                  <tr>
                    <th>プレイガイド</th>
                    <td><a className="has-text-primary" href="http://w.pia.jp/t/agestock-tdch/" target="_blank">チケットぴあHP</a></td>
                  </tr>
                </tbody>
              </table>
              <br />
              <p className="notification">
                当日のイベントの詳細はこちらのHPでご確認くださいませ。
                <br />
                <a href="http://agestock.jp/2019">http://agestock.jp/2019</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AgeStock;
